import restUtils from "core/utils/rest";
import {
  InvestorEvidenceRequestOverview,
  investorEvidenceRequestTransformer,
  EvidenceRequestHistoryItem,
  evidenceRequestHistoryTransformer,
  requiredEvidenceTypesTransformer,
  RqdEvidenceTypeWithDocCategories,
  investorEvidenceRequestDetailTransformer,
  InvestorEvidenceRequestDetail,
  EvidenceRequestUpdatePayload
} from "./transformers/requiredEvidence";


export const getEvidenceTypes = (investorId: string): Promise<RqdEvidenceTypeWithDocCategories[]> => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-request-types`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.payload.map(requiredEvidenceTypesTransformer);
  });
};

export const getInvestorEvidenceRequests = (investorId: string, types: RqdEvidenceTypeWithDocCategories[]): Promise<InvestorEvidenceRequestOverview[]> => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return investorEvidenceRequestTransformer(response.rows, types);
  });
};

export const getEvidenceRequestHistory = (investorId: string, typeCode: string): Promise<EvidenceRequestHistoryItem[]> => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests/${typeCode}/timeline`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return response.rows.map((el: any) => evidenceRequestHistoryTransformer(el));
  });
};

export const getEvidenceRequestDetail = (investorId: string, typeCode: string): Promise<InvestorEvidenceRequestDetail> => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests/${typeCode}`;
  return restUtils.call("PortalApi", url, "GET").then((response: any) => {
    return investorEvidenceRequestDetailTransformer(response.payload);
  });
};

export const updateEvidenceRequest = (investorId: string, payload: EvidenceRequestUpdatePayload) => {
  const url = `hubwise-api/aml/investors/${investorId}/evidence-requests`;
  return restUtils.call("PortalApi", url, "POST", payload);
};
